import { findIndex, isEmpty } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';

import * as types from './constants';
import { sorts } from '../../../pages/Performance/components/ExportsTab/sort';
import { generateQueryFromString, removeFromQueryString } from '../../../utils/queryString';

const initialDate = () => {
  const currentDate = moment(new Date());
  const startSubtract = currentDate.clone().subtract(30, 'days').format();

  return { key: 'date', filterTitle: 'Date', selected: true, value: { since: startSubtract, until: currentDate.format(), type: 'last_days', number: 30 } };
};

export const initialState = {
  listData: {
    dataTable: [],
    allSelected: false,
    // campaign_modifiers: [],
    loading: false,
    tagsLoading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false,
    message: null,
    tags: [],
    filters: [
      { ...initialDate() },
      { key: 'users', filterTitle: 'Users', selected: false, value: [] },
      { key: 'tags', filterTitle: 'Tags', selected: false, value: [] },
      { key: 'campaigns', filterTitle: 'Campaigns', selected: false, value: [] },
      { key: 'sort', filterTitle: 'Sort', selected: true, value: sorts.default }
    ]
  }
};

const actions = {

  // Get Performance Exports
  [types.GET_PERFORMANCE_EXPORTS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_EXPORTS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        ...payload
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_EXPORTS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        errors_api: payload
      }
    };

    return { ...data };
  },

  // Operations
  [types.UPDATE_USER_PERFORMANCE_EXPORTS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => el.owner_uuid === payload.uuid ? {
      ...el,
      user: payload
    } : el);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.SET_PERFORMANCE_EXPORTS_FILTER]: (state, { payload }) => {
    const index = findIndex(state.listData.filters, x => x.key === payload.key);
    const updatedFilters = [...state.listData.filters];
    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      if (typeof updatedFilters[index].value === 'string' || Array.isArray(updatedFilters[index].value)) {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value);
      } else {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value.type);
      }
    }

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1
      }
    };

    return { ...data };
  },

  [types.SET_PERFORMANCE_EXPORTS_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.listData.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], ...filter, selected: true };
    });

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1,
        queryParsed: true
      }
    };

    return { ...data };
  },

  [types.CLEAR_PERFORMANCE_EXPORTS_FILTERS]: (state, { payload: { filterToUpdate, mobile } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.listData.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.listData.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].selected = filterToUpdate.selected;
      }

      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: updatedFilters,
          curr_page: 1
        }
      };

      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return { ...data };
    } else {
      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: [
            { ...initialDate() },
            { key: 'users', filterTitle: 'Users', selected: false, value: [] },
            { key: 'tags', filterTitle: 'Tags', selected: false, value: [] },
            { key: 'campaigns', filterTitle: 'Campaigns', selected: false, value: [] },
            { key: 'sort', filterTitle: 'Sort By', selected: true, value: sorts.default }
          ],
          curr_page: 1
        }
      };

      const query = generateQueryFromString(window.location.search);

      if (query.tab) {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}?${queryString.stringify({ tab: query.tab })}`);
      } else {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}`);
      }

      return { ...data };
    }
  },

  [types.PERFORMANCE_EXPORTS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1,
        queryParsed: true
      }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

